import http from "./httpService";
import { IncidentsInputeTypes } from "../pages/Incidents";

const apiEndpoint = process.env.REACT_APP_API_URL + "/incidents";

export const IncidentService = async (params: IncidentsInputeTypes) => {
  const { data } = await http.post(apiEndpoint, { ...params });
  return data;
};

export const updateIncidentService = async (params: any, id: string) => {
  delete params._id;
  delete params.__v;

  const { data } = await http.put(apiEndpoint + `/${id}`, { ...params });
  return data;
};

export default IncidentService;
